import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'
import { detectAndValidateEnvironment, setGlobalBootstrap } from './utils/appBootstrap'

// Early detection and validation BEFORE React initialization
async function initializeApp() {
  console.log('🚀 Starting app initialization with early detection...');
  
  try {
    // Phase 1: Early detection and validation (BEFORE i18n)
    const bootstrap = await detectAndValidateEnvironment();
    setGlobalBootstrap(bootstrap);
    
    // Phase 2: Load i18n after bootstrap is complete
    const { initializeI18n } = await import('./i18n');
    await initializeI18n();
    
    // Phase 3: Render React app with bootstrap data
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App bootstrap={bootstrap} />
      </React.StrictMode>,
    );
    
    console.log('✅ App initialization complete');
    
  } catch (error) {
    console.error('❌ App initialization failed:', error);
    
    // Fallback: render app without bootstrap data
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App bootstrap={null} />
      </React.StrictMode>,
    );
  }
}

// Start the application
initializeApp();